module.exports = __webpack_public_path__ + "img/weather-image.ebdfe5fe.svg";